import { render, staticRenderFns } from "./profile-switch-btn.vue?vue&type=template&id=01b1292c&scoped=true&"
import script from "./profile-switch-btn.vue?vue&type=script&lang=js&"
export * from "./profile-switch-btn.vue?vue&type=script&lang=js&"
import style0 from "./profile-switch-btn.vue?vue&type=style&index=0&id=01b1292c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1292c",
  null
  
)

export default component.exports